import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DashboardIcon from "@material-ui/icons/Dashboard";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ArticleIcon from "@mui/icons-material/Article";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CampaignIcon from "@mui/icons-material/Campaign";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import DescriptionIcon from "@mui/icons-material/Description";
import EventIcon from "@mui/icons-material/Event";
import KeyIcon from "@mui/icons-material/Key";
import LogoutIcon from "@mui/icons-material/Logout";
import MessageIcon from "@mui/icons-material/Message";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import PaymentIcon from "@mui/icons-material/Payment";
import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import { Box } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import React, { useState } from "react";
import Swal from "sweetalert2";

const LayoutMenu = (props) => {
  const [fold, setFlod] = useState({
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
  });
  const { login } = props;

  const onLogout = () => {
    Swal.fire({
      title: "로그아웃 하시겠습니까?",
      showCancelButton: true,
      sconfirmButtonText: "예",
      cancelButtonText: "아니오",
      closeOnCalcel: true,
    }).then((result) => {
      if (result.isConfirmed == true) {
        localStorage.setItem("token", "");
        window.location.href = "/";
      }
    });
  };

  const onCollapse = (target) => {
    setFlod((state) => {
      const newState = { ...state };
      newState[target] = !newState[target];
      return newState;
    });
  };

  // 메뉴 데이터 객체 정의
  const menuItems = [
    {
      title: "대시보드",
      icon: <DashboardIcon />,
      href: "/home",
      // roles 없음 (공통)
    },
    { type: "divider" },
    {
      title: "결제관리",
      icon: <PaymentIcon />,
      collapseIndex: 0,
      roles: ["100", "500"],
      children: [
        {
          title: "구매관리",
          href: "/order",
          icon: <SpeakerNotesIcon />,
          roles: ["100", "500"],
        },
        {
          title: "구매관리(로그)",
          href: "/order_log",
          icon: <SpeakerNotesIcon />,
          roles: ["500"],
        },
        {
          title: "쿠폰관리",
          href: "/coupon",
          icon: <SpeakerNotesIcon />,
          roles: ["100", "500"],
        },
        {
          title: "쿠폰관리(로그)",
          href: "/coupon_log",
          icon: <SpeakerNotesIcon />,
          roles: ["500"],
        },
        {
          title: "포인트 관리",
          href: "/point",
          icon: <SpeakerNotesIcon />,
          roles: ["100", "500"],
        },
        {
          title: "포인트관리(로그)",
          href: "/point_log",
          icon: <SpeakerNotesIcon />,
          roles: ["500"],
        },
        {
          title: "할인쿠폰관리",
          href: "/dcoupon",
          icon: <SpeakerNotesIcon />,
          roles: ["500", "100"],
        },
        {
          title: "할인쿠폰관리(발행)",
          href: "/dcoupon_issue",
          icon: <SpeakerNotesIcon />,
          roles: ["100", "500"],
        },
      ],
    },
    { type: "divider" },
    {
      title: "환불관리",
      icon: <PaymentIcon />,
      collapseIndex: 3,
      roles: ["100", "500"],
      children: [
        {
          title: "환불관리",
          href: "/refund",
          icon: <SpeakerNotesIcon />,
          roles: ["100", "500"],
        },
        {
          title: "쿠폰반환관리",
          href: "/return",
          icon: <SpeakerNotesIcon />,
          roles: ["100", "500"],
        },
      ],
    },
    { type: "divider" },
    {
      title: "예약관리",
      icon: <ArticleIcon />,
      collapseIndex: 1,
      roles: ["100", "500"],
      children: [
        {
          title: "예약보드",
          href: "/reservation",
          icon: <SpeakerNotesIcon />,
          roles: ["100", "500"],
        },
        {
          title: "예약로그",
          href: "/reservation_log",
          icon: <SpeakerNotesIcon />,
          roles: ["100", "500"],
        },
        {
          title: "프리퀀시",
          href: "/frequency",
          icon: <SpeakerNotesIcon />,
          roles: ["100", "500"],
        },
        {
          title: "사은품신청",
          href: "/gift",
          icon: <SpeakerNotesIcon />,
          roles: ["100", "500"],
        },
      ],
    },
    { type: "divider" },
    {
      title: "상품관리",
      icon: <CardGiftcardIcon />,
      href: "/item",
      roles: ["500", "100"],
    },
    {
      title: "회원관리",
      icon: <AccountBoxIcon />,
      href: "/member",
      roles: ["100", "500"],
    },
    {
      title: "강사관리",
      icon: <AccountBoxIcon />,
      href: "/teacher",
      roles: ["100", "500"],
    },
    {
      title: "이력서관리",
      icon: <DescriptionIcon />,
      href: "/resume",
      roles: ["100", "500"],
    },
    {
      title: "푸시관리",
      icon: <MessageIcon />,
      href: "/push",
      roles: ["100", "500"],
    },
    {
      title: "코드관리",
      icon: <SettingsIcon />,
      href: "/basecode",
      roles: ["500"],
    },
    {
      title: "What's New",
      icon: <EventIcon />,
      href: "/whatsnew",
      roles: ["100", "500"],
    },
    { type: "divider" },
    {
      title: "리포트",
      icon: <PaymentIcon />,
      collapseIndex: 4,
      // roles 없음 (공통)
      children: [
        {
          title: "카드매출",
          href: "/report_card",
          icon: <SpeakerNotesIcon />,
        },
        {
          title: "쿠폰매출",
          href: "/report_coupon",
          icon: <SpeakerNotesIcon />,
        },
        {
          title: "마케팅 활동 보고서",
          href: "/report_marketing",
          icon: <CampaignIcon />,
        },
        {
          title: "FC 업무 보고서",
          href: "/report_fc",
          icon: <PlaylistAddCheckCircleIcon />,
        },
        {
          title: "보고서 문항 관리",
          href: "/report_marketing_question",
          icon: <AssignmentIcon />,
          roles: ["500"],
        },
        {
          title: "가맹문의",
          href: "/board?id=ask",
          icon: <ContactMailIcon />,
          roles: ["500"],
        },
      ],
    },
    { type: "divider" },
    {
      title: "리뷰이벤트",
      icon: <DescriptionIcon />,
      href: "/review",
      // roles 없음 (공통)
    },
    {
      title: "운영시간관리",
      icon: <MoreTimeIcon />,
      href: "/center_open",
      // roles 없음 (공통)
    },
    {
      title: "스마트키관리",
      icon: <KeyIcon />,
      href: "/smart_key",
      // roles 없음 (공통)
    },
  ];

  return (
    <Box>
      {menuItems.map((item, index) => {
        // 권한 체크: roles가 있고 빈 배열이 아니며, 현재 레벨이 포함되지 않은 경우 숨김
        if (
          item.roles &&
          item.roles.length > 0 &&
          !item.roles.includes(login.level)
        ) {
          return null;
        }

        // 구분선 렌더링
        if (item.type === "divider") {
          return <Divider key={`divider-${index}`} />;
        }

        // 하위 메뉴가 있는 경우 (Collapse)
        if (item.children) {
          return (
            <React.Fragment key={`menu-group-${index}`}>
              <ListItemButton
                component="a"
                href="#"
                onClick={() => onCollapse(item.collapseIndex)}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.title} />
              </ListItemButton>
              <Collapse in={fold[item.collapseIndex]} sx={{ pl: 1 }}>
                {item.children.map((child, cIndex) => {
                  // 하위 메뉴 권한 체크
                  if (
                    child.roles &&
                    child.roles.length > 0 &&
                    !child.roles.includes(login.level)
                  ) {
                    return null;
                  }
                  return (
                    <ListItemButton
                      key={`child-${index}-${cIndex}`}
                      component="a"
                      href={child.href}
                    >
                      <ListItemIcon>{child.icon}</ListItemIcon>
                      <ListItemText primary={child.title} />
                    </ListItemButton>
                  );
                })}
              </Collapse>
            </React.Fragment>
          );
        }

        // 일반 단일 메뉴
        return (
          <ListItemButton key={`menu-${index}`} component="a" href={item.href}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.title} />
          </ListItemButton>
        );
      })}

      <Box sx={{ height: 40 }}></Box>
      <Divider />
      <Box
        sx={{
          bgcolor: "rgba(71, 98, 130, 0.2)",
          pb: 0,
        }}
      >
        <ListItemButton>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary="로그아웃" onClick={onLogout} />
        </ListItemButton>
      </Box>
    </Box>
  );
};

export default LayoutMenu;
